import React, { useEffect } from "react";

import useTextContents from 'common/hooks/useTextContents'
import PageLoader from 'components/PageLoader/PageLoader'
import videoVerificationService from 'service/VideoVerificationService/VideoVerificationService'
import { useNavigate } from 'react-router-dom'
import { AppLinks } from 'enviroment/AppLinks'
import { sleep } from 'common/helpers/helpers'
import { useSelector } from 'react-redux'
import { AppState } from 'store'
import { BasicInfoFieldsNames } from 'FormDefinitions/BasicInfoForm/BasicInfoFields'
import { ChooseIdentityMethodTypes } from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPageProps'
import analyticsService from 'service/AnalyticsService/AnalyticsService'

const sendIdentificationVideoVerificationEvent = async(eventTypeName?: string) => {
   try {
      await analyticsService.createSingleAnalyticEvent(eventTypeName)
   }
   catch(error) {
      console.warn('Nie udało się zapisać eventu wideoweryfikacji.', error)
   }
}

/**
 * Komponent obsługujący powrót użytkownika z wideo weryfikacji
*/
const VideoVerificationBackFromPartnerPage = (): JSX.Element => {
   const DEFAULT_SLEEP_TIME = 2000
   const loadersTextContents = useTextContents()
   const navigate = useNavigate()
   const email = useSelector((state: AppState) => state.formState[BasicInfoFieldsNames.Email].value) as string
   const sessionId = useSelector((state: AppState) => state.videoVerificationState.sessionId)
   const analyticsEventTypesNames = useSelector((state: AppState) => state.globalConfigurationState.analyticsEventTypesNames)

   useEffect(() => {
      (async () => {
         const searchParamsFromLink = new URLSearchParams(window.location.search)
         const identityMethodType = searchParamsFromLink.get('identity_method_type') //Pobieramy customowy parametr przekazany wcześniej w linku z wideo weryfikacji.
         const isIdentityVerification = identityMethodType === ChooseIdentityMethodTypes.IDENTITY.toLowerCase()

         try {
            if(isIdentityVerification) {
               await sendIdentificationVideoVerificationEvent(analyticsEventTypesNames?.IdentificationVideoVerificationBack)
            }

            const isUserPassVerification = await videoVerificationService.checkIfUserPassVerification({ email, sessionId })
            await sleep(DEFAULT_SLEEP_TIME) //Sztucznie "przytrzymujemy" użytownika na stronie przez chwilę


            switch(identityMethodType){
               case ChooseIdentityMethodTypes.IDENTITY.toLowerCase(): {
                  if(isUserPassVerification) {
                     await sendIdentificationVideoVerificationEvent(analyticsEventTypesNames?.IdentificationVideoVerificationSucceeded)
                  }

                  navigate(isUserPassVerification? AppLinks.videoVerificationBasicInfoForm : AppLinks.videoVerificationIdentificationErrorPage)
                  break;
               }
               case ChooseIdentityMethodTypes.VERIFICATION.toLowerCase(): {
                  if (!isUserPassVerification) {
                     return navigate(AppLinks.videoVerificationVerificationErrorPage)
                  }
                   
                  const result = await videoVerificationService.videoVerificationVerification({ email, sessionId })
                  navigate(result ? AppLinks.bmWaiting : AppLinks.videoVerificationVerificationErrorPage)

                  break;
               }

               default: {
                  console.error(`Nie znaleziono parametru identity_method_type w linku lub błędna wartość parametru: ${identityMethodType}`)
                  navigate(AppLinks.error)
                  break;
               }
            }
         }
         catch (e: any) {
            if(isIdentityVerification) {
               navigate(AppLinks.videoVerificationIdentificationErrorPage)
               return
            }

            navigate(AppLinks.error)
         }
      })()
   }, [ navigate, email, sessionId, analyticsEventTypesNames ])


   return <PageLoader waitingText={loadersTextContents('loaders.startPage')} />
}

export default VideoVerificationBackFromPartnerPage
